// /app/frontend/src/data/progressionAutoEcole.js
// Trame de progression pratique de l'auto-école — 23 étapes réparties en 3 phases.
// Chaque étape est reliée à la compétence REMC correspondante (permet de rebondir
// vers la fiche pédagogique complète).

export const PROGRESSION = [
  {
    phase: 'Mécanique',
    slug: 'mecanique',
    color: 'red',
    intro: "Prise en main du véhicule : postes, commandes, allure, vitesses, manœuvres. La base indispensable avant de circuler.",
    steps: [
      { id: 'M1',  label: 'Installation au poste de conduite', remc: 'C1b' },
      { id: 'M2',  label: 'Les principales commandes', remc: 'C1a' },
      { id: 'M3',  label: 'Volant sur parking, puis sur route avec positionnement sur la chaussée', remc: 'C1c' },
      { id: 'M4',  label: 'Démarrage, arrêt de précision et en douceur en 1re', remc: 'C1d' },
      { id: 'M5',  label: 'Passer les vitesses jusqu\'en 2 puis arrêt de précision en 2', remc: 'C1f' },
      { id: 'M6',  label: 'Passer les vitesses jusqu\'en 3 puis arrêt de précision en 3', remc: 'C1f' },
      { id: 'M7',  label: 'Passer les vitesses jusqu\'en 3 puis rétrograder en 2 avec arrêt de précision en 2', remc: 'C1f' },
      { id: 'M8',  label: 'Marche arrière en ligne droite et en courbe', remc: 'C1i' },
      { id: 'M9',  label: 'Demi-tour', remc: 'C1i' },
      { id: 'M10', label: 'Passage de vitesses jusqu\'en 5 et rétrogradation', remc: 'C1f' },
      { id: 'M11', label: 'Démarrage en côte', remc: 'C1d' },
      { id: 'M12', label: 'Glissé de 1re', remc: 'C1d' },
      { id: 'M13', label: 'Détection des intersections', remc: 'C2d' },
    ],
  },
  {
    phase: 'Observation',
    slug: 'observation',
    color: 'amber',
    intro: "Prise d'information sur la route : conduite commentée, rétros, angles morts, giratoires, voies d'insertion.",
    steps: [
      { id: 'O1', label: 'Conduite commentée vers l\'avant', remc: 'C2a' },
      { id: 'O2', label: 'Conduite commentée avant et arrière avec rétro intérieur', remc: 'C1h' },
      { id: 'O3', label: 'Rétros int et ext pour changement de direction et dépassement d\'obstacles', remc: 'C1h' },
      { id: 'O4', label: 'Rétros int, ext et angle mort pour changement de direction et dépassement d\'obstacles', remc: 'C1h' },
      { id: 'O5', label: 'Rétros et angle mort dans les giratoires', remc: 'C2f' },
      { id: 'O6', label: 'Voie d\'insertion en centre ville (vers centre d\'examen)', remc: 'C2d' },
      { id: 'O7', label: 'Voie d\'accélération et de décélération hors agglo', remc: 'C3e' },
      { id: 'O8', label: 'Séquence des contrôles avant chaque changement (allure & voie)', remc: 'C1h' },
    ],
  },
  {
    phase: 'Préparation permis',
    slug: 'preparation-permis',
    color: 'emerald',
    intro: "Dernière ligne droite : vérifications, grille de notation, permis blanc en conditions réelles.",
    steps: [
      { id: 'P1', label: 'Carnet de vérification véhicule', remc: 'C1a' },
      { id: 'P2', label: 'Grille de notation, parcours examen', remc: 'C4a' },
      { id: 'P3', label: 'Permis blanc', remc: 'C4b' },
    ],
  },
];

export const STATUTS = [
  { key: 'todo',     label: 'Non abordée',           short: '—',                color: 'white/40'   },
  { key: 'en_cours', label: 'En cours d\'acquisition', short: 'En cours',       color: 'sky-300'    },
  { key: 'acquis',   label: 'Acquise',                short: 'Acquise',         color: 'emerald-300' },
  { key: 'a_revoir', label: 'À revoir',               short: 'À revoir',        color: 'amber-300'  },
];

export const TOTAL_ETAPES = PROGRESSION.reduce((n, p) => n + p.steps.length, 0);
